import {
  type RedtailAdditionalObjects,
  type RedtailWorkflow,
  type RedtailWorkflowStep,
  type RedtailWorkflowTemplate,
} from '../../../../../../../models/Integration'
import { type IntegrationWorkflow, type IntegrationWorkflowStep, type IntegrationWorkflowTemplate } from '../../../../../../../models/IntegrationWorkflow'
import { type IntegrationWorkflowAdapter, toIntegrationWorkflow, toIntegrationWorkflowLists } from '../integrationWorkflow'

export type RedtailStartWorkflowFields = {
  templateId: string
  name: string
  dueDate: Date
  description?: string
}

const fromRedtailStep = (step: RedtailWorkflowStep): IntegrationWorkflowStep => ({
  id: step.id,
  name: step.name ?? null,
  completedAt: step.completedAt ?? null,
  outcomes: (step.workflowStepOutcomes ?? []).map((outcome) => ({
    id: outcome.id,
    name: outcome.name ?? null,
    nextStepId: outcome.nextWorkflowStepId ?? null,
  })),
})

export const fromRedtailWorkflow = (workflow: RedtailWorkflow): IntegrationWorkflow => toIntegrationWorkflow(workflow, fromRedtailStep)

export const fromRedtailTemplate = (template: RedtailWorkflowTemplate): IntegrationWorkflowTemplate => ({
  id: template.redtailOneId,
  name: template.name ?? null,
  description: template.description ?? null,
  milestones: [],
})

export const redtailWorkflowAdapter: IntegrationWorkflowAdapter<RedtailStartWorkflowFields> = {
  capabilities: { stepNote: true },
  toLists: (additionalObjects) => toIntegrationWorkflowLists(additionalObjects as RedtailAdditionalObjects, fromRedtailWorkflow, fromRedtailTemplate),
  buildStartPayload: (fields, externalId) => ({
    workflow_template_id: fields.templateId,
    name: fields.name,
    due_date: fields.dueDate.toISOString(),
    contact_id: externalId,
    ...(fields.description ? { description: fields.description } : {}),
  }),
  buildCompleteStepPayload: ({ outcomeId, note }) =>
    outcomeId ? { outcome_id: outcomeId, step_notes: note } : { complete: true, ...(note ? { step_notes: note } : {}) },
}
